const axios = require("axios");

export const placesAutoCompleteFetchAction = async (searchInput) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/places/placesAutoComplete?input=${searchInput}`
  );

  return response;
};

export const getAllRegionsFetchAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/regions/getAllRegions?pageNumber=${payload?.page}`
  );

  return response.data;
};

export const totalNumberOfRegions = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/regions/totalRegions`
  );

  return response.data;
};

export const createRegionWithMapAction = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/regions/createRegion`,
    payload.regionPayload,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};

export const searchPlacesByNameAction = async (searchInput) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/properties/searchPlacesByName?placeName=${searchInput}`
  );

  return response;
};
